module.exports = __webpack_public_path__ + "static/media/zep.d4e8cb94.png";